import React from 'react'

const noop = () => Promise.resolve()
const LightBoxContext = React.createContext<(lightbox: React.ReactNode) => Promise<void>>(noop)

export default LightBoxContext
